module.exports = [
  require('./rashemen'),
  require('./ruathym'),
]
